import {Button, Tooltip} from "@mui/material";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const ButtonCatalog = ({onClick, text, width, height = 32, disabled = false, icon = true, tooltip}) => {
    return <Tooltip
        title={tooltip}
        placement={"top"}>
        <Button
            onClick={onClick}
            variant="outlined"
            disabled={disabled}
            sx={{
                width: width ?? 'auto',
                minWidth: width ?? 'unset',
                height: height,
                borderRadius: "8px",
                color: (theme) => theme.palette.text.main,
                border: (theme) => `${theme.palette.primary.main} 1px solid`,
                padding: "4px 8px",
                display: 'flex',
                gap: "4px",
                alignItems: "center",
                justifyContent: "flex-start",
                textTransform: 'none',
                flexShrink: 0,
                textAlign: "left",
                whiteSpace: 'nowrap',
                boxSizing: 'border-box',
            }}
        >
            {text}
            {icon && <FormatListBulletedIcon sx={{width: 20, height: 20, flexShrink: 0}}/>}
        </Button>
    </Tooltip>
}
export default ButtonCatalog